module.exports = __webpack_public_path__ + "static/media/izlozba (21).7b79008c.jpg";